import * as React from 'react'
import {
  FIRST_DASH_VIDEO_EN_TRACK_URL,
  FIRST_DASH_VIDEO_URL,
} from '../../../constants'
import { Slide as SlideType } from '../../../typeModules/slide'
import {
  AcceptOrders,
  GetPaid,
  PickupAndDropoff,
  ReadyToDash,
  StartDashing,
  Support,
} from '../../atoms/images/in-app-education'
import { Video } from '../../atoms/video'
import Contact from './contact'
import s from './strings'

const {
  startDashing,
  acceptOrders,
  pickAndDropoff,
  getPaid,
  support,
  readyToDash,
} = s

export const SlideDeck1: SlideType[] = [
  {
    key: 'start-dashing',
    title: startDashing.title(),
    graphic: <StartDashing />,
    description: startDashing.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'accept-orders',
    title: acceptOrders.title(),
    graphic: <AcceptOrders />,
    description: acceptOrders.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'pick-and-dropoff',
    title: pickAndDropoff.title(),
    graphic: <PickupAndDropoff />,
    description: pickAndDropoff.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'get-paid',
    title: getPaid.title(),
    graphic: <GetPaid />,
    description: getPaid.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'support',
    title: support.title(),
    graphic: <Support />,
    description: support.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'ready-to-dash',
    title: readyToDash.title(),
    graphic: <ReadyToDash />,
    showReadyToDashButton: true,
    showPagination: true,
  },
]

export const SlideDeck2: SlideType[] = [
  {
    key: 'start-dashing',
    title: startDashing.title(),
    graphic: <StartDashing />,
    description: startDashing.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'accept-orders',
    title: acceptOrders.title(),
    graphic: <AcceptOrders />,
    description: acceptOrders.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'pick-and-dropoff',
    title: pickAndDropoff.title(),
    graphic: <PickupAndDropoff />,
    description: pickAndDropoff.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'get-paid',
    title: getPaid.title(),
    graphic: <GetPaid />,
    description: getPaid.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'support',
    title: support.title(),
    graphic: <Support />,
    description: support.description(),
    showNextButton: true,
    showPagination: true,
    showReadyToDashButton: false,
  },
  {
    key: 'ready-to-dash',
    title: readyToDash.title(),
    graphic: <ReadyToDash />,
    showReadyToDashButton: true,
    showMoreQuestionsButton: true,
    showPagination: true,
  },
  {
    key: 'contact',
    title: 'contact', // for tracking - never displayed, so no need for i18n
    raw: <Contact />,
    showBackButton: true,
    showReadyToDashButton: false,
  },
]

export const SlideDeckVideo: SlideType[] = [
  {
    key: 'video',
    title: readyToDash.title(),
    showReadyToDashButton: true,
    graphic: (
      <Video
        width={320}
        height={240}
        autoPlay={true}
        controls={true}
        type="video/mp4"
        src={FIRST_DASH_VIDEO_URL}
        track={[
          {
            src: FIRST_DASH_VIDEO_EN_TRACK_URL,
            kind: 'captions',
            srcLang: 'en',
            label: 'English',
          },
        ]}
      />
    ),
  },
]
